/** @format **/

/**
 * External dependencies
 */
import { __ } from '@wordpress/i18n';

// Mapping of transaction types to display string.
export const displayType = {
	vat_invoice: __( 'Tax Invoice', 'woocommerce-payments' ),
};
